import React from 'react';
import { starterKits } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const StarterKits = ({ onAddToCart }) => {
  return (
    <section id="kits" className="py-20 bg-slate-900 text-white relative overflow-hidden">
      <div className="absolute top-0 right-0 -mr-20 -mt-20 opacity-10">
        <SafeIcon icon={FiIcons.FiPackage} size={400} />
      </div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <span className="text-lime-400 font-bold tracking-widest uppercase text-sm mb-2 block">Value Bundles</span>
          <h2 className="text-4xl lg:text-5xl font-black uppercase tracking-tight">Starter Kits</h2>
          <p className="text-gray-400 mt-4 max-w-2xl mx-auto">Everything you need to switch to electric, boxed up with massive savings.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {starterKits.map(kit => (
            <div key={kit.id} className="bg-slate-800 border-2 border-slate-700 hover:border-lime-400 transition-colors flex flex-col sm:flex-row rounded-sm overflow-hidden">
              <div className="sm:w-2/5 h-48 sm:h-auto relative">
                <img src={kit.image} alt={kit.name} className="w-full h-full object-cover" />
                <div className="absolute top-0 left-0 bg-lime-400 text-slate-900 font-black px-3 py-1 text-sm uppercase">
                  Save ${(kit.originalPrice - kit.price).toFixed(2)}
                </div>
              </div>
              <div className="p-6 sm:w-3/5 flex flex-col justify-between">
                <div>
                  <h3 className="text-2xl font-black text-white uppercase mb-4">{kit.name}</h3>
                  <ul className="space-y-2 mb-6">
                    {kit.items.map((item, idx) => (
                      <li key={idx} className="flex items-center text-gray-300 text-sm font-medium">
                        <SafeIcon icon={FiIcons.FiCheck} className="text-lime-400 mr-2 flex-shrink-0" />
                        {item}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="flex items-end justify-between border-t border-slate-700 pt-4">
                  <div>
                    <span className="block text-gray-400 line-through text-sm">${kit.originalPrice}</span>
                    <span className="text-3xl font-black text-lime-400">${kit.price}</span>
                  </div>
                  <button 
                    onClick={() => onAddToCart(kit)}
                    className="bg-white hover:bg-lime-400 text-slate-900 font-bold py-2 px-4 uppercase text-sm tracking-wide transition-colors rounded-sm"
                  >
                    Add Kit
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StarterKits;